function emptyItem() {
  return { highlights: [], strikes: [] };
}

function samePane(range, next) {
  if (!range || !next) return false;
  if (range.pane !== next.pane) return false;
  if (next.pane === 'option') return range.optionLabel === next.optionLabel;
  return true;
}

function overlaps(a, b) {
  return a.start < b.end && a.end > b.start;
}

export function subtractInterval(ranges, interval, matchFn) {
  const list = Array.isArray(ranges) ? ranges : [];
  if (!interval || interval.start >= interval.end) return list.slice();
  const out = [];
  list.forEach((r) => {
    if (typeof matchFn === 'function' && !matchFn(r)) {
      out.push(r);
      return;
    }
    if (r.end <= interval.start || r.start >= interval.end) {
      out.push(r);
      return;
    }
    if (r.start < interval.start) {
      out.push({ ...r, end: interval.start });
    }
    if (r.end > interval.end) {
      out.push({ ...r, start: interval.end });
    }
  });
  return out.filter((r) => r.start < r.end);
}

export function applyHighlightToItem(item, range) {
  const cur = item || emptyItem();
  if (!range || range.start >= range.end) return cur;
  const highlights = subtractInterval(
    cur.highlights || [],
    range,
    (r) => samePane(r, range)
  );
  highlights.push({
    pane: range.pane,
    start: range.start,
    end: range.end,
    color: range.color,
    ...(range.pane === 'option' ? { optionLabel: range.optionLabel } : {}),
  });
  highlights.sort((a, b) => a.start - b.start);
  return { ...cur, highlights, strikes: cur.strikes || [] };
}

export function removeHighlightFromItem(item, range) {
  const cur = item || emptyItem();
  if (!range || range.start >= range.end) return cur;
  return {
    ...cur,
    highlights: subtractInterval(
      cur.highlights || [],
      range,
      (r) => samePane(r, range)
    ),
    strikes: cur.strikes || [],
  };
}

export function toggleStrikeOnItem(item, range) {
  const cur = item || emptyItem();
  if (!range || range.start >= range.end) return cur;
  const strikes = cur.strikes || [];
  const hit = strikes.some((r) => samePane(r, range) && overlaps(r, range));
  if (hit) {
    return {
      ...cur,
      highlights: cur.highlights || [],
      strikes: subtractInterval(strikes, range, (r) => samePane(r, range)),
    };
  }
  return {
    ...cur,
    highlights: cur.highlights || [],
    strikes: [
      ...strikes,
      {
        pane: range.pane,
        start: range.start,
        end: range.end,
        ...(range.pane === 'option' ? { optionLabel: range.optionLabel } : {}),
      },
    ],
  };
}
